import { render } from "./EditAlarmcodesForSystem.vue?vue&type=template&id=37f86c65"
import script from "./EditAlarmcodesForSystem.vue?vue&type=script&lang=js"
export * from "./EditAlarmcodesForSystem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__